import React from 'react';
import { CalendarDaysIcon, PlusIcon } from '@heroicons/react/24/outline';

export interface AgendaEmptyStateProps {
    filtersActive: boolean;
    onClearFilters: () => void;
    /** Omitted entirely in read-only consumers: no Add affordance to offer. */
    onAddAppointment?: () => void;
}

export const AgendaEmptyState: React.FC<AgendaEmptyStateProps> = ({
    filtersActive,
    onClearFilters,
    onAddAppointment
}) => (
    <div className="h-full grid place-items-center px-8 text-center">
        <div>
            <div className="mx-auto mb-3 h-10 w-10 grid place-items-center rounded-full bg-white border border-gray-200 text-gray-400">
                <CalendarDaysIcon className="h-[18px] w-[18px]" />
            </div>
            <h3 className="text-[13.5px] font-semibold text-gray-800">
                {filtersActive ? 'No appointments match' : 'No appointments scheduled'}
            </h3>
            <p className="mx-auto mt-1.5 max-w-xs text-[12.5px] leading-relaxed text-gray-500">
                {filtersActive
                    ? 'Try another day or clear the filters to see the full agenda.'
                    : onAddAppointment
                      ? 'Book records updates, aligner fittings and retainer deliveries here. They show on the patient record too.'
                      : 'Scheduled appointments will show here.'}
            </p>
            {(filtersActive || onAddAppointment) && (
                <button
                    type="button"
                    onClick={filtersActive ? onClearFilters : onAddAppointment}
                    className="mt-4 inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white hover:bg-gray-800"
                >
                    {filtersActive ? (
                        'Clear filters'
                    ) : (
                        <>
                            <PlusIcon className="h-[15px] w-[15px]" /> Add appointment
                        </>
                    )}
                </button>
            )}
        </div>
    </div>
);

export default AgendaEmptyState;
